import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';

import $ from 'jquery';

import didInsert from 'webapp/modifiers/did-insert';

import type InfolayerItem from 'webapp/models-custom/infolayer-item/status-objects';

interface Args {
	model: InfolayerItem;
	onClose: () => void;
}

export default class InfolayerTypeStatusObjectsComponent extends Component<Args> {
	@action
	insertJQueryElement(node: HTMLElement): void {
		const el = this.args.model.statusObjectsJQueryElement;
		if (el) {
			$(node).append(el);
		}
	}
	<template>
		<div role="button" class="infolayer {{@model.classes}}" {{on "click" @onClose}}>
			<div>
				<p {{didInsert this.insertJQueryElement}}></p>
			</div>
		</div>
	</template>
}
